import { Box } from "@mui/material";
import type { MetricsCellProjection } from "../metricsColumns";
import { StatusDot } from "./StatusDot";

export function MetricsCellContent({ cell }: { cell: MetricsCellProjection }) {
  if (cell.kind === "partner-status") {
    return <StatusDot band={cell.band}>{cell.label}</StatusDot>;
  }

  return (
    <Box
      component="span"
      sx={cell.emphasis === "critical" ? { color: "error.main", fontWeight: 700 } : undefined}
    >
      {cell.text}
    </Box>
  );
}
